import Icon from '@stone/ui/icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import analytics from '@stone/utils/analytics';
const SearchBtn = (props) => {
    const { t } = useTranslation();
    return (React.createElement("button", { "aria-label": t('label.search'), onClick: () => {
            analytics.search('search click');
            props.handleOpen();
        }, className: "menu-heading", "aria-haspopup": "dialog" },
        React.createElement(Icon, { name: "search", family: "16" })));
};
export default SearchBtn;
